import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e8ecb02")

_pushScopeId("data-v-6e8ecb02")
const _hoisted_1 = {
  class: "ui__detect_main",
  id: "detectInfo"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "ui__line_main" }, null, -1)
const _hoisted_3 = { class: "ui__detect_body" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "ui__detect_title" }, "检测信息", -1)
const _hoisted_5 = { class: "ui__detect_cnt" }
const _hoisted_6 = { class: "flex-box" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "flex-label" }, "检测师姓名", -1)
const _hoisted_8 = { class: "flex-value" }
const _hoisted_9 = { class: "flex-box" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "flex-label" }, "报告出具日期", -1)
const _hoisted_11 = { class: "flex-value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.state.name), 1)
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.state.date), 1)
        ])
      ])
    ])
  ]))
})